function fn_part_qr() {
    var $part = $(".part_qr");
    $part.find("[data-qr]").on("click",function(e){
        e.preventDefault();
        var $data_qr = $(this).data("qr");
        var $data_sub_html = $(this).data("sub-html");
        $(this).lightGallery({
            dynamic: true,
            counter: false,
            download: false,
            fullScreen: false,
            zoom: false,
            dynamicEl: [{
                "src": $data_qr,
                "subHtml": $data_sub_html
            }]
        });
    });
}